<template>
  <div id="authWrapper">
    <div class="columns">
      <div class="column is-half is-offset-one-quarter">
        <h1 class="title">Curriculum Totaal</h1>

        <div v-if="maintenance" class="notification is-warning">
          <div class="content" v-html="message"></div>
        </div>

        <div v-else class="box">
          <form>
            <div class="field">
              <label for="email" class="field-label">E-mail adres</label>
              <div class="field">
                <p class="control">
                  <input class="input" type="text" v-model="email" @keyup.enter="signIn">
                </p>
              </div>
            </div>

            <div class="field">
              <label for="password" class="field-label">Wachtwoord</label>
              <div class="field">
                <p class="control">
                  <input class="input" type="password" v-model="password" @keyup.enter="signIn">
                </p>
              </div>

              <p class="help"><router-link :to="{ name: 'forgot-password', params: { fromLogin: email } }">Wachtwoord vergeten</router-link></p>
            </div>

            <save-buttons
              :disabled="!email || !password"
              :noCancel="true"
              @save="signIn"
              saveCaption="Inloggen">
            </save-buttons>
          </form>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half is-offset-one-quarter">
        <div id="cookieNotification" class="notification">
          <p><strong>Cookies</strong></p>
          <p>Deze applicatie maakt gebruik van functionele cookies om login sessies te beheren. Er worden geen tracking cookies gebruikt of andere middelen waarmee het gedrag van de gebruiker geanalyseerd kan worden.</p>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <h2 class="subtitle is-6"><i class="far fa-copyright"></i> Learning Matters BV 2019</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  components: {
    SaveButtons
  },
  data () {
    return {
      email: null,
      password: null,
      message: '<p><strong>Zaterdag 2 maart: onderhoud</strong></p><p>Het programma is momenteel niet beschikbaar in verband met onderhoud. Dit duur naar verwachting tot ongeveer 12:00.</p>',
      maintenance: false
    }
  },
  methods: {
    signIn () {
      this.$store.dispatch('account/signIn', {
        'email': this.email,
        'password': this.password
      })
    }
  }
}
</script>

<style scoped>
  #cookieNotification {
    margin-top: 60px;
  }

  .title, .subtitle {
    text-align: center;
    margin: 5rem 0;
  }

  .footer {
    position: relative;
    bottom: 0;
    height: auto;
    width: 100%;
    padding: 0;
    background-color: #fff;
  }

  .box {
    margin: 0 auto;
    max-width: 20rem;
  }
</style>
